import React, {children} from 'react'

export default function CardBox ({children}){

    return(
        
    <>
     {/* bg-[#888374]/30 */}
      <div className="w-full mx-auto md:py-10   rounded-xl shadow-xl ">
        {children}
     </div>
    </>    
    )
}